import React, { useState } from 'react'
import contactBG from '../../assets/contact-bg.svg'
import { useForm } from 'react-hook-form'
import { CheckboxGroup } from '../../common/components/Inputs/CheckboxGroup'
import { InputField, MultiLineField } from 'cwp-components/forms/InputFields'
import Project from '../../../../common/project'

const ContactPage = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })
  const [isChecked, setIsChecked] = useState<boolean>(false)

  const handleChange = () => setIsChecked(!isChecked)

  const onSubmit = async (data) => {
    const payload = {
      user_email: data.emailAddress,
      template_id: 'd-1e1a43689def47f88e694d2f123ddaf0',
      context: {
        first_name: data.firstName,
        last_name: data.lastName,
        phone: data.phone,
        message: data.message,
      },
    }
    try {
      const response = await fetch(`${Project.liveApi}send-email/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })

      const result = await response.json()

      if (response.ok) {
        alert('Email sent successfully')
      } else {
        console.error('Error:', result)
        alert('There was a problem sending your message.')
      }
    } catch (error) {
      console.error('Fetch error:', error)
      alert('Something went wrong. Please try again.')
    }
  }

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  const alphaPattern = /^[A-Za-z]+$/
  const phonePattern = /^[0-9]{10,15}$/

  return (
    <div className='flex flex-col h-[calc(100%-64px)] justify-center overflow-x-hidden items-center relative'>
      <img
        src={contactBG}
        alt='Contact background'
        className='absolute inset-0 w-full h-full object-cover'
      />
      <div className='flex flex-col py-0 sm:py-10 justify-center bg-[#D1D3D7] bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white shadow-[0 1px 26px 0 rgba(187, 199, 215, 0.5] border-opacity-40 rounded-xl py-[50px] md:py-[100px] px-[74px] sm:px-[94px] md:px-[64px] lg:px-[164px] xl:px-[201px] xs:p-[40px]'>
        <h1 className='mb-4 text-[25px] md:text-[32px] font-bold text-[#001A3D] leading-normal'>
          Contact us
        </h1>
        <form onSubmit={handleSubmit(onSubmit)} className='mt-8'>
          <div className='grid md:grid-cols-2 gap-4'>
            <div className='flex flex-col justify-self-start item-center '>
              <InputField
                register={register}
                required={true}
                regexPattern={alphaPattern}
                id='firstName'
                label='First name'
                placeholder='firstName'
                className='w-80'
                errors={errors}
                errorMessage='Please enter your first name'
              />
            </div>
            <div className='flex flex-col justify-self-start item-center '>
              <InputField
                register={register}
                required={true}
                regexPattern={alphaPattern}
                id='lastName'
                label='Last name'
                placeholder='lastName'
                className='w-80'
                errors={errors}
                errorMessage='Please enter your last name'
              />
            </div>
            <div className='flex flex-col justify-self-start item-center '>
              <InputField
                register={register}
                required={true}
                regexPattern={emailPattern}
                id='emailAddress'
                label='Email address'
                placeholder='emailAddress'
                className='w-80'
                errors={errors}
                errorMessage='Please enter an email connected to an account'
              />
            </div>
            <div className='flex flex-col justify-self-start item-center '>
              <InputField
                register={register}
                required={true}
                regexPattern={phonePattern}
                id='phoneNumber'
                label='Phone number'
                placeholder='phoneNumber'
                className='w-80'
                errors={errors}
                errorMessage='Please enter your phone number'
              />
            </div>
          </div>
          <div className='flex flex-col justify-self-start item-center '>
            <MultiLineField
              register={register}
              required={true}
              id='message'
              label='Message'
              placeholder='message'
              className='md:w-[660px] w-[320px] mt-4 h-full'
              errors={errors}
              errorMessage='Please enter your message'
            />
          </div>
          <div className='flex justify-start mt-2'>
            <CheckboxGroup
              id='terms'
              onChange={handleChange}
              checked={isChecked}
              label={
                <span className='text-base text-[#6E7785]'>
                  I agree with the
                  <a
                    href='https://www.legalutopia.co.uk/terms-of-use-consumer'
                    className='!text-blue inline-block px-1'
                  >
                    Terms
                  </a>
                  and
                  <a
                    href='https://www.legalutopia.co.uk/privacy-policy-web'
                    className='!text-blue inline-block px-1'
                  >
                    Privacy policy
                  </a>
                </span>
              }
              name='terms'
            />
          </div>

          <div className='flex justify-end'>
            <button
              className={`p-2 px-[14px] rounded-md font-['DM_Sans'] text-base font-medium leading-5 tracking-[0.4px] ${
                isChecked
                  ? 'bg-[#020251] shadow-[0_1px_4px_0_rgba(0,0,0,0.25)] text-white hover:text-[#65C2D7] cursor-pointer'
                  : 'bg-[#F4F4F4] shadow-[0_1px_4px_0_rgba(0,0,0,0.25)] text-[#A0ABBE] cursor-not-allowed'
              }`}
              disabled={!isChecked}
            >
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ContactPage
